/* eslint-disable @typescript-eslint/no-explicit-any */
import { MixedInventoryBookingState } from './interface';

/**
 * Default state for Mixed Inventory Booking Store
 *
 * Matches existing SessionUpdateContext pattern with safe defaults
 */

export const initialMixedInventoryState: MixedInventoryBookingState = {
  // Search Criteria - initialized with empty/default values
  searchCriteria: {
    propertyId: '',
    checkInDate: '',
    checkOutDate: '',
    totalRooms: 1,
    roomSearchCriteria: [
      {
        roomIndex: 1,
        adults: 2,
        children: 0,
        childrenAges: [],
      },
    ],
  },

  // Room Progression - starting state
  roomProgression: {
    currentRoomIndex: 1, // Always start with Room 1
    roomsAdded: 0, // No rooms in cart initially
    roomsRemaining: 1, // Computed: totalRooms - roomsAdded
  },

  // Cart State - no cart until first room added
  cartState: {
    cartId: null,
    expirationTime: null,
    rooms: [],
    cartExtensionCount: 0,
  },

  // UI State - all modals closed by default
  uiState: {
    showAbandonCartModal: false,
    showDateChangeModal: false,
    showInventoryShortage: false,
    showReviewResLink: false, // Computed: roomsAdded >= 1
    showRoomAddedFlyout: false,
  },

  // Navigation State - initial state
  navigation: {
    canGoBack: false, // No back navigation on Room 1 initially
    previousRoomIndex: null,
    returnedFromCheckout: false,
    checkoutReturnAction: null,
  },

  // Error State - no errors initially
  errors: {
    cartCreationError: null,
    inventoryShortage: false,
    datesMismatch: false,
  },

  // Metadata - session tracking
  metadata: {
    version: 'v1.0',
    timestamp: new Date().toISOString(),
    sessionId: `mi-booking-${Date.now()}`,
  },
};
